var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5675 7.7775C14.2765 8.04182 14.9074 8.48065 15.4018 9.0534C15.8963 9.62615 16.2383 10.3143 16.3963 11.0543C16.5543 11.7943 16.5232 12.5621 16.3058 13.2869C16.0884 14.0116 15.6918 14.6699 15.1526 15.2007C14.6134 15.7316 13.949 16.1179 13.221 16.3239C12.4929 16.53 11.7247 16.5491 10.9873 16.3796C10.2498 16.2101 9.56709 15.8573 9.00212 15.354C8.43716 14.8507 8.00823 14.213 7.755 13.5M5.25 4.5H6V7.5M12.5325 10.41L13.0575 10.9425L10.9425 13.0575M10.5 6C10.5 8.48528 8.48528 10.5 6 10.5C3.51472 10.5 1.5 8.48528 1.5 6C1.5 3.51472 3.51472 1.5 6 1.5C8.48528 1.5 10.5 3.51472 10.5 6Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.59df4a13e9a5aee162a573e5f99a6119.svg";
export { ForwardRef as ReactComponent };